import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  root: {
    height: '100%',
  },
  tabTitle: {
    // fontWeight: 'bold !important',
  },
  tabPanelMain: {
    height: '100%',
    margin: '0 auto',
  },
  tabPanel: {
    height: '100%',
  },
}));
